export RestaurantsGroup from './RestaurantsGroup';




// WEBPACK FOOTER //
// ./sdk/scripts/entities/restaurantsGroup/index.js